import { createSlice } from "@reduxjs/toolkit";
import { getLoyaltyPointSettingAction, insertUpdateLoyaltyPointAction } from "../../actions/settingActions/loyaltyPointAction";
import { toast } from 'react-toastify';
import { Enums } from "../../../helper/constants/enums";

const INITIAL_STATE = {
    selectedLoyaltyPoint: {
        data: null,
        apiMsg: {
            message: null,
            status: null,
            type: null,
        },
    },
    insertUpdateDetails: {
        data: {},
        apiMsg: {
            message: null,
            status: null,
            type: null,
        },
    }
};

const loyaltyPointReducer = createSlice({
    name: "LoyaltyPoint",
    initialState: INITIAL_STATE,
    reducers: {
        RESET(state, action) {
            state = INITIAL_STATE;
        },
        ResetLoyaltyPointDetailsState(state, action) {
            state.insertUpdateDetails = INITIAL_STATE.insertUpdateDetails;
        }
    },
    extraReducers: (builder) => {
        builder.addCase(getLoyaltyPointSettingAction.fulfilled, (state, action) => {
            state.selectedLoyaltyPoint.data = action.payload.data;
            state.selectedLoyaltyPoint.apiMsg.status = action.meta.requestStatus;
            if (action.payload.message) {
                state.selectedLoyaltyPoint.apiMsg.message = action.payload.message.message;
            }
        });

        builder.addCase(getLoyaltyPointSettingAction.pending, (state, action) => {
            state.selectedLoyaltyPoint.data = null;
            state.selectedLoyaltyPoint.apiMsg.message = action.meta.requestStatus;
            state.selectedLoyaltyPoint.apiMsg.status = action.meta.requestStatus;
        });

        builder.addCase(getLoyaltyPointSettingAction.rejected, (state, action) => {
            state.selectedLoyaltyPoint.apiMsg.message = action.error.message;
            state.selectedLoyaltyPoint.apiMsg.status = action.meta.requestStatus;

            toast.error(action.error.message ? action.error.message : "Something went wrong please try again", {
                position: "bottom-center",
                toastId: "error"
            });
        });

        builder.addCase(insertUpdateLoyaltyPointAction.fulfilled, (state, action) => {
            if (action.meta.arg) {
                state.insertUpdateDetails.data = {
                    ...action.meta.arg,
                    pointConfigurationID: action.payload.data.data
                };
            }

            state.insertUpdateDetails.apiMsg.status = action.meta.requestStatus;
            state.insertUpdateDetails.apiMsg.message = action.payload.message.message;

            toast.success(action.payload.message.message, {
                position: "bottom-center",
                toastId: "success"
            });
        });

        builder.addCase(insertUpdateLoyaltyPointAction.pending, (state, action) => {
            state.insertUpdateDetails.apiMsg.status = action.meta.requestStatus;
        });

        builder.addCase(insertUpdateLoyaltyPointAction.rejected, (state, action) => {
            state.insertUpdateDetails.apiMsg.message = action.error.message;
            state.insertUpdateDetails.apiMsg.status = action.meta.requestStatus;

            toast.error(action.error.message ? action.error.message : "Something went wrong please try again", {
                position: "bottom-center",
                toastId: "error"
            });
        });
    }
});

export const { RESET, ResetLoyaltyPointDetailsState } = loyaltyPointReducer.actions;
export default loyaltyPointReducer.reducer;
